import styled from 'styled-components/native';

export const ExportList = styled.FlatList`
  padding-top: 16px;
  padding-horizontal: 16px;
`;
